import {React, useContext, useMemo} from 'external/react'
import Subjects from 'components/catalogue-subjects/Subjects'
import Courses from 'components/catalogue-courses'
import Units from 'components/units'
import Lessons from 'components/catalogue-search-results'
import './catalogue.styl'
import { TeacherContext } from './context'

const views = [
  [Subjects, ({subject, searching}) => !subject && !searching],
  [Courses, ({match: {url}}) => /\/..\/.+\/catalogue\/C.$/.test(url)],
  [Lessons, ({searching}) => searching == 'lessons'],
  [Units, ({match: {url}}) => /\/..\/.+\/catalogue\/C.\/C...G../.test(url)]
]

const Catalogue = () => {
  const context = useContext(TeacherContext)
  const [Section] = useMemo(() => views.find(([_,isMatch]) => isMatch(context)) || views[0], [context.match, context.subject, context.searching])
  return (<div><Section /></div>)
}

export {Catalogue as default}